// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Volume Button

hbcVolumeButton = {};

hbcVolumeButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  button._flags.muted = false;

  button.canEnable = function () {
    return soundManager.soundAvailable();
  };

  button.showButton = function () {
    if (this.canShow() && this.buttons !== undefined) {
      if (button._flags.muted) {
        this.button.buttonSprite.texture = this.buttons.textures[1];
        /*switch(layoutController.getCurrentLayout()){
					case "landscape_default":{

						break;
					}
					case "landscape_mobile":
					case "portrait_default":
					case "portrait_mobile":{
						this.button.buttonSprite.texture = this.buttonsPortrait.textures[1];
						break;
					}
				}*/
      } else {
        this.button.buttonSprite.texture = this.buttons.textures[0];
        /*switch(layoutController.getCurrentLayout()){
					case "landscape_default":{

						break;
					}
					case "landscape_mobile":
					case "portrait_default":
					case "portrait_mobile":{
						this.button.buttonSprite.texture = this.buttonsPortrait.textures[0];
						break;
					}
				}*/
      }
      this.button.visible = true;
    } else {
      this.hideButton();
    }
  };

  button.onPressedCallback = function () {
    const muted = !this._flags.muted;
    messageBus.postImmediate("audio:stateChanged", {
      type: "audio:stateChanged",
      muted,
    });
    this._flags.muted = muted;
  };

  button.onCurrentMuteState = function (state) {
    this._flags.muted = state.muted;
  };

  button.onGameConfigEvent = function () {
    this.buttons = textureParser.textureLists["volumeButtons"];
    this.buttonsPortrait = textureParser.textureLists["volumeButtonsPortrait"];
  };

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    button.onGameConfigEvent.bind(button)
  );
  messageBus.subscribe(
    "audio:currentMuteState",
    button.onCurrentMuteState.bind(button)
  );

  return button;
};

hbcVolumeButton.initialise = function (json, object) {};

hbcVolumeButton.getFilesRequired = function () {
  return [
    ...textureParser.getFilesRequired("volumeButtons"),
    "ui/Desktop_Sound_On_Button.png",
    "ui/Desktop_Sound_Off_Button.png",
  ];
};

resourceManager.registerObjectType(
  "hbcVolumeButton",
  hbcVolumeButton.create,
  hbcVolumeButton.initialise,
  hbcVolumeButton.getFilesRequired
);
